export default "__VITE_ASSET__bW$1Gcb8__"